<template>
  <v-menu v-if="currentUser" offset-y color="white" bottom nudge-bottom="14">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on">
        <p v-if="$store.state.translation.language == 'en'" class="mb-0 d-none d-sm-flex text-capitalize primary--text">
          English
        </p>
        <p v-else-if="$store.state.translation.language == 'de'"
           class="mb-0 d-none d-sm-flex text-capitalize primary--text">
          Deutsch
        </p>
        <v-icon small class="ml-1 d-none d-sm-block" color="primary">expand_more</v-icon>
        <v-icon class="d-sm-none" color="primary">translate</v-icon>
      </v-btn>
    </template>
    <v-list color="white">
      <v-list-item v-for="locale in supportedLocales" :key="locale" @click="switchLocale(locale)">
        <p v-if="locale == 'en'" class="mb-0 text-capitalize primary--text">
          English
        </p>
        <p v-else-if="locale == 'de'" class="text-capitalize primary--text">
          Deutsch
        </p>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import {Translator} from "@/plugins/translation";
import i18next from 'i18next';
import Utils from '@/modules/core/services/utils';
import UsersService from '@/modules/core/services/users-service';

export default {
  name: "LanguageMenu",
  data() {
    return {
      isInitialised: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    supportedLocales() {
      return Translator.supportedLocales;
    }
  },
  methods: {
    // Own
    switchLocale(locale) {
      if (i18next.language !== locale) {
        this.$store.commit('translation/storeLanguage', locale);
        this.$store.commit('translation/loadNamespaces');

        Utils.showOverlay();
        i18next.changeLanguage(locale, () => {
          this.updateUserLanguage(locale);
          Utils.hideOverlay();
        });
      }
    },

    updateUserLanguage(locale) {
      if (!this.isInitialised) return;

      let language = 'ENGLISH';
      if (locale === 'de') {
        language = 'GERMAN';
      }

      UsersService.updateUserLanguage(language,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:update-success', {name: this.$t('common:language')}));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:update-failure', {name: this.$t('common:language')}))
          }
      );
    }
  },
  created() {
    if (Translator.getUserSupportedLocale() != this.$store.state.translation.language) {
      this.switchLocale(this.$store.state.translation.language);
    } else {
      this.switchLocale(Translator.getUserSupportedLocale());
    }
    this.isInitialised = true;
  }
}
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>